import React from 'react'
import { ChevronDownIcon } from '@heroicons/react/24/outline'
import { useCallback, useState } from 'react'
import Image from 'next/image'
import styles from './kdt-design-5th.module.scss'

const InternshipAccordion = () => {
  const [isOpen1, setIsOpen1] = useState(true)
  const [isOpen2, setIsOpen2] = useState(false)
  const [isOpen3, setIsOpen3] = useState(false)

  const onOpenHandler1 = useCallback(() => {
    setIsOpen1(!isOpen1)
  }, [isOpen1])

  const onOpenHandler2 = useCallback(() => {
    setIsOpen2(!isOpen2)
  }, [isOpen2])

  const onOpenHandler3 = useCallback(() => {
    setIsOpen3(!isOpen3)
  }, [isOpen3])

  return (
    <>
      <li className="group list-none overflow-hidden px-4 pt-2.5 lg:px-8" onClick={onOpenHandler1}>
        <div className="cursor-pointer list-none group-open:pb-1">
          <div
            className={`${styles.curriculum_accordion_dot_box} flex flex-row items-center gap-5`}
          >
            <div
              className={`${
                isOpen1
                  ? 'border-[2px] border-yellow-450 bg-yellow-450 shadow-[0_0_10px_0_#FF7710]'
                  : 'border-[2px] border-trueGray-800 bg-[#FFF3EB]'
              } z-10 flex h-2 w-2 shrink-0 items-center justify-center rounded-full`}
            >
              <span></span>
            </div>
            <div
              className={`${
                isOpen1 ? 'border-x border-t' : 'border'
              } flex w-full items-center justify-between gap-x-3 border-black bg-white px-4 py-3`}
            >
              <div className="flex flex-col gap-2">
                <p
                  className={`${
                    isOpen1 ? 'text-label-normal' : 'text-label-neutral'
                  } text-base font-bold leading-normal`}
                >
                  디자인 스튜디오 ‘디엘스(The Else)’
                  <br />
                  <b className="max-w-fit text-yellow-450">정규직 전환형 인턴십</b> 기회
                </p>
              </div>
              <ChevronDownIcon
                className={`${
                  isOpen1 ? 'rotate-180 transform' : ''
                } ml-auto h-auto w-4 shrink-0 grow-0 text-label-normal lg:w-8`}
              />
            </div>
          </div>
        </div>
        {/* open */}
        {isOpen1 && (
          <div className="flex w-full">
            <div className="ml-7 flex-1 border-x border-b border-black bg-white px-4 pb-3 pt-2">
              <div className="w-full bg-alternative px-4 py-3">
                <Image
                  src="https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-design-5th/section4_img1_logo_new_m.png"
                  layout="fill"
                  objectFit="cover"
                  className="!relative z-10 w-full object-cover"
                  alt="-"
                />
              </div>
              <dl className="my-5 flex flex-col gap-2">
                <dt className="text-sm font-semibold text-label-normal">기업소개</dt>
                <div className="bg-alternative px-4 py-3" role="group">
                  <dd className="text-sm leading-normal text-label-neutral">
                    디엘스는 디자인과 기술의 경계를 허무는 크리에이티브 웹 에이전시로, 최적의 UXUI
                    설계를 통해 고객의 비즈니스를 성장시키는 기업입니다.
                  </dd>
                  <dd className="mt-3 flex flex-col border-t pt-3">
                    <p
                      className={`${styles.text_dot} ${styles.text_dot_section4} text-sm leading-normal text-label-neutral`}
                    >
                      서울시, LG CNS 등 대기업들의 프로젝트 진행
                    </p>
                    <p
                      className={`${styles.text_dot} ${styles.text_dot_section4} text-sm leading-normal text-label-neutral`}
                    >
                      GDWeb, I-Web awards, Awwwards 등 국내외 웹 어워드 수상
                    </p>
                  </dd>
                </div>
              </dl>
              <dl className="flex flex-col gap-2">
                <dt className="text-sm font-semibold text-label-normal">채용안내</dt>
                <dd className="bg-alternative px-4 py-3 text-sm leading-normal text-label-neutral">
                  채용 시, 과제 전형 100% 면제!
                </dd>
              </dl>
            </div>
          </div>
        )}
      </li>
      <li className="group list-none overflow-hidden px-4 pt-2.5 lg:px-8" onClick={onOpenHandler2}>
        <div className="cursor-pointer list-none group-open:pb-1">
          <div
            className={`${styles.curriculum_accordion_dot_box} flex flex-row items-center gap-5`}
          >
            <div
              className={`${
                isOpen2
                  ? 'border-[2px] border-yellow-450 bg-yellow-450 shadow-[0_0_10px_0_#FF7710]'
                  : 'border-[2px] border-trueGray-800 bg-[#FFF3EB]'
              } z-10 flex h-2 w-2 shrink-0 items-center justify-center rounded-full`}
            >
              <span></span>
            </div>
            <div
              className={`${
                isOpen2 ? 'border-x border-t' : 'border'
              } flex w-full items-center justify-between gap-x-3 border-black bg-white px-4 py-3`}
            >
              <div className="flex flex-col gap-2">
                <p
                  className={`${
                    isOpen2 ? 'text-label-normal' : 'text-label-neutral'
                  } text-base font-bold leading-normal`}
                >
                  멋쟁이사자처럼 인턴십 기회
                </p>
              </div>
              <ChevronDownIcon
                className={`${
                  isOpen2 ? 'rotate-180 transform' : ''
                } ml-auto h-auto w-4 shrink-0 grow-0 text-label-normal lg:w-8`}
              />
            </div>
          </div>
        </div>
        {/* open */}
        {isOpen2 && (
          <div className="flex w-full">
            <div className="ml-7 flex-1 border-x border-b border-black bg-white px-4 pb-3 pt-2">
              <div className="w-full bg-alternative px-4 py-3">
                <p className="text-sm leading-normal text-label-neutral">
                  3개월 동안 현업 프로젝트에 참여하여, 데이터 기반으로 문제를 정의하고 해결책을
                  도출하는 실전 경험을 쌓습니다.
                </p>
              </div>
              <div className="my-5 w-full bg-alternative px-4 py-3">
                <Image
                  src="https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-design-5th/section4_img2_m.png"
                  layout="fill"
                  objectFit="cover"
                  className="!relative z-10 w-full object-cover"
                  alt="-"
                />
                <p className="mt-1.5 text-xs leading-normal text-label-neutral">
                  *실제 인턴 이미지
                </p>
              </div>
              <dl className="flex flex-col gap-2">
                <dt className="text-sm font-semibold text-label-normal">
                  현업 프로젝트에 100% 참여한 포트폴리오
                </dt>
                <dd className="bg-alternative px-4 py-3">
                  <div className="mb-3 w-full border-b pb-3">
                    <Image
                      src="https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-design-5th/section4_img3_m.gif"
                      layout="fill"
                      objectFit="cover"
                      className="!relative z-10 w-full object-cover"
                      alt="-"
                      unoptimized
                    />
                  </div>
                  <div className="w-full">
                    <Image
                      src="https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-design-5th/section4_img4_m.gif"
                      layout="fill"
                      objectFit="cover"
                      className="!relative z-10 w-full object-cover"
                      alt="-"
                      unoptimized
                    />
                  </div>
                </dd>
              </dl>
            </div>
          </div>
        )}
      </li>
      <li className="group list-none overflow-hidden px-4 pt-2.5 lg:px-8" onClick={onOpenHandler3}>
        <div className="cursor-pointer list-none group-open:pb-1">
          <div
            className={`${styles.curriculum_accordion_dot_box} flex flex-row items-center gap-5`}
          >
            <div
              className={`${
                isOpen3
                  ? 'border-[2px] border-yellow-450 bg-yellow-450 shadow-[0_0_10px_0_#FF7710]'
                  : 'border-[2px] border-trueGray-800 bg-[#FFF3EB]'
              } z-10 flex h-2 w-2 shrink-0 items-center justify-center rounded-full`}
            >
              <span></span>
            </div>
            <div
              className={`${
                isOpen3 ? 'border-x border-t' : 'border'
              } flex w-full items-center justify-between gap-x-3 border-black bg-white px-4 py-3`}
            >
              <div className="flex flex-col gap-2">
                <p
                  className={`${
                    isOpen2 ? 'text-label-normal' : 'text-label-neutral'
                  } text-base font-bold leading-normal`}
                >
                  멋사 로켓단
                </p>
              </div>
              <ChevronDownIcon
                className={`${
                  isOpen3 ? 'rotate-180 transform' : ''
                } ml-auto h-auto w-4 shrink-0 grow-0 text-label-normal lg:w-8`}
              />
            </div>
          </div>
        </div>
        {/* open */}
        {isOpen3 && (
          <div className="flex w-full">
            <div className="ml-7 flex-1 border-x border-b border-black bg-white px-4 pb-3 pt-2">
              <div className="w-full bg-alternative px-4 py-3">
                <p className="text-sm leading-normal text-label-neutral">
                  프론트엔드, 백엔드 등 다양한 직무의 개발자들과 함께, 실무와 동일한 협업 환경에서
                  6주간 UXUI 프로젝트를 진행합니다.
                </p>
              </div>
              <dl className="mt-5 flex flex-col gap-2">
                <dt className="text-sm font-semibold text-label-normal">
                  멋사 로켓단 프로젝트 사진
                </dt>
                <dd className="bg-alternative px-4 py-3">
                  <div className="w-full">
                    <Image
                      src="https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-design-5th/section4_img5_m.png"
                      layout="fill"
                      objectFit="cover"
                      className="!relative z-10 w-full object-cover"
                      alt="-"
                    />
                  </div>
                </dd>
              </dl>
            </div>
          </div>
        )}
      </li>
    </>
  )
}

export default InternshipAccordion
